/**
 * Các enum chi tiết trong thông báo
 */
export default {
  /**
   * Tính giá xuất kho
   */
  CalculatePrice: {
    /**
     * Bắt đầu tính giá
     */
    Start: 1,
    /**
     * Hoàn thành tính giá
     */
    Complete: 2,
  },

  /**
   * Ghi sổ bỏ ghi theo lô
   */
  PostBath: {
    /**
     * Loại
     */
    Type: {
      /**
       * Bỏ ghi
       */
      UnPost: 0,

      /**
       * Ghi sổ
       */
      Post: 1,
    },

    /**
     * Trạng thái
     */
    Status: {
      /**
       * Bắt đầu
       */
      Start: 1,

      /**
       * Hoàn thành
       */
      Complete: 2,
    },
  },

  /**
   * Khóa sổ
   */
  CloseBook: {
    /**
     * Trạng thái
     */
    Status: {
      /**
       * Bắt đầu khóa sổ
       */
      Start: 1,

      /**
       * Bắt đầu khóa sổ
       */
      Complete: 2,
    },

    /**
     * Loại lỗi
     */
    ErrorType: {
      /**
       * Có chứng từ chưa ghi sổ đc
       */
      NotPosted: 1,

      /**
       * Thêm chứng từ chưa ghi sổ vào trước ngày khóa sổ
       */
      BeforePostedDate: 2,
    },
  },
  /**
   * Bảo trì dữ liệu
   */
  MaintainData: {
    /**
     * Trạng thái
     */
    Status: {
      /**
       * Bắt đầu bảo trì
       */
      Start: 1,
      /**
       * Hoàn thành bảo trì
       */
      Complete: 2,
    },
  },
  /**
   * Tạo dữ liệu năm trước
   */
  CreateDataPrevYear: {
    /**
     * Trạng thái
     */
    Status: {
      /**
       * Thất bại
       */
      Error: 0,
      /**
       * Thành công
       */
      Success: 1,
    },
    /**
     * Loại lỗi
     */
    ErrorType: {
    },
  },
};
